import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "../NewsPages/Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card3 from "../Images/NewsFeeds/Lab2Field/IMG_20250903_160341_134.jpg";
import Card4 from "../Images/NewsFeeds/Lab2Field/IMG_20250903_151402_188.jpg";
import Card1 from "../Images/NewsFeeds/Lab2Field/IMG_20250903_140842_723.jpg";

function LabToField() {
  return (
    <div className="art-page">
      <SEO
        title="From Lab to Field: Advancing Regional Collaboration in Clean Cooking!"
        description="CIRCODU hosted a Rwandan delegation to share knowledge and experiences on clean cooking and regional collaboration."
        keywords="CIRCODU, clean cooking, regional collaboration, indoor air quality, sustainable development, Uganda, Rwanda, GIZ, Standards Board, Energy Group, Ministry of Infrastructure, Development Bank, Private Developers, clean cooking knowledge exchange, clean cooking best practices, clean cooking standards, clean cooking certification, clean cooking testing, clean cooking laboratory, clean cooking regional partnerships, clean cooking peer learning, clean cooking solutions, sustainable clean cooking, resilient frameworks for clean cooking, East Africa clean cooking"
        url="/From-Lab-to-Field-Advancing-Regional-Collaboration-in-Clean-Cooking"
        image={Card3}
        datePublished="2025-09-03"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              From Lab to Field: Advancing Regional Collaboration in Clean
              Cooking!
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            {/* Date */}
            <div className="art-date">
              <span className="art-date__dot" />
              September 3, 2025
            </div>

            {/* Title */}
            <h1 className="art-title">
              From Lab to Field: Advancing Regional Collaboration in Clean
              Cooking!
            </h1>

            {/* Body */}
            <div className="texty">
              <img
                src={Card3}
                alt="Rwandan delegation visit to CIRCODU Cookstove Laboratory"
                className="art-img"
              />

              <p>
                Centre for Integrated Research and Community Development Uganda
                (CIRCODU) had the honour of hosting the Rwandan delegation from
                GIZ Rwanda-Burundi "Reducing Climate Impact of Cooking in
                Rwanda" (ReCIC Project), Rwanda Standards Board (RSB), Rwanda
                Energy Group (REG/EDCL), Rwanda Ministry of Infrastructure
                (MININFRA), Development Bank of Rwanda (BRD) PLC, and Energy
                Private Developers (EPD). The visit was a knowledge exchange
                focused on clean cooking, with the primary objective of
                fostering regional collaboration and helping RSB prepare for ISO
                certification by learning from Uganda's successful clean cooking
                ecosystem.
              </p>
              <img
                src={Card4}
                alt="Rwandan delegation visit to CIRCODU Cookstove Laboratory"
                className="art-img"
              />
              <p>
                The delegation toured the CIRCODU Cookstove Laboratory and
                gained insights and experiences on several key topics,
                including:
              </p>

              <ol>
                <li>
                  🌱 Lessons learned on Standards, certification and testing
                  best practices
                </li>
                <li>
                  ⚡ Strategies for achieving and maintaining ISO accreditation
                </li>
                <li>
                  🤝 Building and strengthening stronger regional partnerships
                  and peer learning for cleaner cooking solutions
                </li>
              </ol>

              <p>
                This visit helped build bridges and share knowledge, with the
                ultimate goal of creating and shaping stronger resilient
                frameworks for sustainable clean cooking solutions across the
                East Africa region. 💡🔥
              </p>

              <img
                src={Card1}
                alt="Rwandan delegation visit to CIRCODU Cookstove Laboratory"
                className="art-img"
              />
            </div>

            {/* CTA */}
            <div className="art-cta">
              <p>
                Are you interested in getting your Cookstoves Tested, Monitored
                and Evaluated? CIRCODU has the expertise and equipment to test
                Cookstove Efficiency, Safety, Durability, and Emissions. Contact
                the Laboratory at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call us on <a href="tel:+256392004309">+256 (0) 392 004 309</a>{" "}
                / <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            {/* Back */}
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LabToField;
